import { useAuth } from "../../../../context";
import { useMutation } from "react-query";
import { ScopeOne } from "../../../../api/supplier-questionnaire/tabs";

export function useCreateScopeOne(config) {
  const { callApi } = useAuth();
  return useMutation(({questionnaireId, data}) =>
    callApi(ScopeOne.createScopeOne, { questionnaireId, data }), config);
}

export function useUpdateScopeOne(config) {
  const { callApi } = useAuth();
  return useMutation(({questionnaireId, id, data}) =>
    callApi(ScopeOne.updateScopeOne, { questionnaireId, id, data }), config);
}